import { createTheme } from '@mui/material/styles';

const theme = createTheme({
// GREEN: #AFBD47 | rgb(175,189,71)
// RED: #ED403F | rgb(237,64,63)
// BLUE: #8196E5 | rgb(129,150,229)
  components: {
    MuiButton: {
      defaultProps: {
        color: 'inherit',
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          '&.Mui-completed': {
            color: 'grey',
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#fff',
    },
    // secondary was 'grey' in MUI v4. In v4 that resolved secondary.main to grey.A400 = #303030.
    // In MUI v5 grey.A400 = #bdbdbd, so we pin the value explicitly.
    secondary: {
      main: '#303030',
    },
    // action.selected was rgba(0,0,0,0.14) in MUI v4; v5 default is rgba(0,0,0,0.08). Pin to v4 value.
    action: {
      selected: 'rgba(0, 0, 0, 0.14)',
    },
    blue: '#8196E5',
    green: '#AFBD47',
    red: '#ED403F',
  },
  typography: {
    fontFamily: 'Montserrat',
    body1: {
      fontFamily: 'Ingra',
    },
    body2: {
      fontFamily: 'Ingra',
    },
  },
});

export default theme;
